import { Card, CardBody, Button } from '@heroui/react';
import React from 'react';

interface BuyerPaginationProps {
  page: number;
  totalPages: number;
  isLoading: boolean;
  filteredBuyersCount: number;
  totalBuyers: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export const BuyerPagination: React.FC<BuyerPaginationProps> = ({
  page,
  totalPages,
  isLoading,
  filteredBuyersCount,
  totalBuyers,
  onPreviousPage,
  onNextPage,
}) => {
  return (
    <Card className="mt-6">
      <CardBody>
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="text-sm text-default-600">
            <span>
              Showing{' '}
              <span className="font-medium">
                {isLoading ? '...' : filteredBuyersCount}
              </span>{' '}
              of{' '}
              <span className="font-medium">
                {isLoading ? '...' : totalBuyers}
              </span>{' '}
              buyers
            </span>
          </div>
          <div className="flex gap-2">
            <Button
              variant="bordered"
              size="sm"
              onClick={onPreviousPage}
              isDisabled={page === 1 || isLoading}
            >
              Previous
            </Button>
            <Button
              variant="bordered"
              size="sm"
              onClick={onNextPage}
              isDisabled={isLoading || page >= totalPages}
            >
              Next
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
